import 'css-chunksrc/client/pages/planzoneLogsPage/skeleton/card/styles.scss';export default {
  "card": "_card_3bxk0_1",
  "body": "_body_3bxk0_9",
  "author": "_author_3bxk0_17",
  "avatar": "_avatar_3bxk0_25",
  "content": "_content_3bxk0_31",
  "date": "_date_3bxk0_37"
};